import React, { useEffect } from 'react';
import { TemplateEmpresas } from 'components/templates';
import { VagaCard } from '../components/VagaCard';
import { useProcessos } from 'hooks';
import { Link } from 'react-router-dom';

import * as S from './styles';

import Andamento from 'assets/icons/andamento.svg';
import Home from 'assets/icons/home.svg';

export const VagasAndamento = () => {
  const { processos, getProcessosEmpresa } = useProcessos();

  useEffect(() => {
    getProcessosEmpresa('?status=ativada');
  }, []);

  return (
    <TemplateEmpresas title="PORTAL DA EMPRESA">
      <S.Row>
        <Link to="/empresas/vagas">
          <S.Banner>
            <img src={Home} alt="" />
            Início
          </S.Banner>
        </Link>
        <S.Banner>
          <img src={Andamento} alt="" />
          Andamento
        </S.Banner>
      </S.Row>

      <S.Title>Vagas</S.Title>
      {processos?.map((item) => (
        <VagaCard processo={item} candidateText="ATIVA" />
      ))}
    </TemplateEmpresas>
  );
};
